import axios from "axios";

const base_url = process.env.REACT_APP_CO2OPT_BASE_URL;

export const createContact = async (payload) => {
  return await axios
    .post(`${base_url}/v1/messenger/create-contact`, payload)
    .then((res) => res)
    .catch(function (error) {
      console.error("E10033", error);
      if (error.response) {
        return { status: error.response.status };
      }
    });
};
